/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import "./DesignServicePromo.scss";

export default function DesignServicePromo({ onDesignServiceClicked, ...restProps }: any) {
  // @ts-expect-error TS(6133): 'e' is declared but its value is never read.
  function handleDesignServiceClick(e: any) {
    onDesignServiceClicked?.();
  }

  return (
    <div {...restProps} className={cn("design-service-promo scope-812a63cf", restProps.className)}>
      <span className="design-service-promo__text scope-812a63cf">
        {" "}
        Need edits? Use our <strong className="scope-812a63cf">FREE</strong>{" "}
        <a
          className="design-service-promo__link scope-812a63cf"
          href="#"
          onClick={e => {
            e.preventDefault();
            handleDesignServiceClick(e);
          }}
          data-testid="design-service-promo-link"
        >
          <strong className="scope-812a63cf">design service!</strong>
        </a>
      </span>
    </div>
  );
}
